<div class="p-grid">
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">State Id</div>
        {{stateDetail?.stateId}}
    </div>
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">State Name</div>
        {{stateDetail?.stateName}}
    </div>
</div>

<div class="p-grid">
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Is Active</div>{{stateDetail?.isActive}}
    </div>
</div>
